export default __webpack_public_path__ + "static/media/gallery_09.1f7dee1b.jpg";